import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationCoordinationService {
    private newNotificationSubject = new BehaviorSubject<boolean>(false);

    // Observable that emits when new notifications are received
    newNotification$ = this.newNotificationSubject.asObservable();

    // Method to notify that a new notification was received
    notifyNewNotification(): void {
        this.newNotificationSubject.next(true);
    }

    // Method to reset the notification flag
    resetNotificationFlag(): void {
        this.newNotificationSubject.next(false);
    }
}
